import { createSelector } from '@reduxjs/toolkit';

import { ModelCategory, ProjectLayoutModel } from '@paragon/contract-library';

import { RootState } from '../store';

export const getProjectLayoutModels = createSelector(
  (state: RootState) => state.layoutModels,

  (layoutModels): ProjectLayoutModel[] =>
    Object.values(layoutModels).filter(
      (layoutModel) => layoutModel.category === ModelCategory.Project,
    ) as ProjectLayoutModel[],
);
